// !FSD: we can't change entry point of the app without ejecting, so we need to keep this file here.
import React from 'react';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import { createRoot } from 'react-dom/client';
import { App, reportWebVitals } from 'app';

dayjs.extend(objectSupport);
const rootElement = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
